import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../shared/FormStyles/Button';
import { htmlSanitizer } from '../../../lib/helpers';

const TileButtonComponent = ({
  className,
  onClick,
  answer,
  correctAnswer,
  isDisabled,
  questionType,
  subtype,
  points,
  answerIndex,
  tileAnswerIndex,
  complete = false,
}) => {
  const [shakeButton, setShakeButton] = useState(className);
  const [buttonText, setButtonText] = useState(answer);
  const [disable, setDisable] = useState(isDisabled);
  const [variant, setVariant] = useState('answerBlue');
  const { t } = useTranslation('tileView');
  const pointsWording =
    window.Airbo.currentBoard.points_wording ||
    t('tileQuiz.defaultPointsWording');

  useEffect(() => {
    setButtonText(answer);
  }, [answer]);

  useEffect(() => {
    if (complete && tileAnswerIndex === answerIndex) {
      setVariant('successGreen');
    } else if (complete && !correctAnswer) {
      setVariant('answerBlue');
    }
  }, [complete, correctAnswer]);

  const animateButton = () => {
    if (correctAnswer) {
      setButtonText(t('tileQuiz.buttonPoints', { points, pointsWording }));
      setVariant('successGreen');
    } else {
      setShakeButton('shakeX');
      setVariant('errorRed');
      setButtonText(t('tileQuiz.tryAgain'));
    }
  };

  const buttonClick = e => {
    if (
      (questionType === 'question_answer' && answerIndex === 0) ||
      (subtype === 'change_email' && answerIndex === 0) ||
      (subtype === 'invite_spouse' && answerIndex === 0)
    )
      return onClick(e);

    animateButton();
    setDisable(true);
    return onClick(e, correctAnswer);
  };

  return (
    <>
      <Button
        className={shakeButton}
        disabled={disable || isDisabled}
        variant={variant}
        onClick={e => buttonClick(e)}
        width="100%"
        my="6px"
        dangerouslySetInnerHTML={htmlSanitizer(buttonText)}
      />
    </>
  );
};

export default TileButtonComponent;
